
import SettlementPauseComponent from "@/components/system_settings/SettlementPause.vue";

export default {
  components: { SettlementPauseComponent },
};
